export type ProcessGeoPin = {
  letter: string;
  title: string;
  lat: number;
  lng: number;
};

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function firstGeoFromMedia(media: any[] | undefined): { lat: number; lng: number } | null {
  if (!Array.isArray(media)) {
    return null;
  }
  for (const item of media) {
    if (item?.lat == null || item?.lng == null) {
      continue;
    }
    const lat = Number(item.lat);
    const lng = Number(item.lng);
    if (isUsableGeo(lat, lng)) {
      return { lat, lng };
    }
  }
  return null;
}

function isUsableGeo(lat: number, lng: number): boolean {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return false;
  }
  if (Math.abs(lat) < 0.000001 && Math.abs(lng) < 0.000001) {
    return false;
  }
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}

export function formatLatLng(geo: { lat: number; lng: number }): string {
  return `${geo.lat.toFixed(6)}, ${geo.lng.toFixed(6)}`;
}

export function processGeoPins(
  processes: Array<{ title?: string; media?: any[] }>
): ProcessGeoPin[] {
  const pins: ProcessGeoPin[] = [];
  processes.forEach((process, index) => {
    const geo = firstGeoFromMedia(process?.media);
    if (!geo) {
      return;
    }
    pins.push({
      letter: LETTERS.charAt(index) || String(index + 1),
      title: String(process?.title || `Process ${index + 1}`).trim() || `Process ${index + 1}`,
      lat: geo.lat,
      lng: geo.lng,
    });
  });
  return pins;
}

export function displayUploadedBy(value: any): string {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value === "object") {
    return displayUploadedBy(
      value.uploadByName || value.uploadedByName || value.name || value.uploadBy
    );
  }
  const text = String(value).trim();
  if (!text || text === "undefined" || text === "null") {
    return "";
  }
  if (/^[a-f0-9]{24}$/i.test(text)) {
    return "";
  }
  return text;
}
